import {
  eventTypesFetched,
  eventTypesRequestStarted,
  eventTypesRequestError,
} from '../EventSubscriptionActions';
import EventTypeFetch from 'fetch/EventTypeFetch';
import { reportError } from './AppErrorThunk';
import { getUserPermissibleStateCodes } from 'lib/AuthHelper';
import { moduleConfig } from 'lib/config/appConstants';

export function eventTypeFetched(criterias = {}, callback = null) {
  return function (dispatch) {
    dispatch(eventTypesRequestStarted()); // Comment reason: set isFetching be true, so "Loading..." always show, not hide

    // In a real world app, you also want to
    // catch any error in the network call.
    return EventTypeFetch.getAll(criterias)
      .then((json) => {
        const productType =
          criterias?.application?.toUpperCase() === moduleConfig.EB.shortName
            ? moduleConfig.EB.userInfoProductCode
            : moduleConfig.PC.userInfoProductCode;
        const stateCodes = getUserPermissibleStateCodes(productType) || [];
        // user has a CL or EB license , access all DOT, OSHA and  eb_renewal_reminder alert types
        if (json?.event_types?.length > 0 && stateCodes?.length > 0) {
          const newEventTypes = json.event_types;
          // sort wc, dot, bta and others
          if (criterias?.application?.toUpperCase() === moduleConfig.PC.shortName) {
            moveToFirstOfArray(newEventTypes, 'bta_renewal_reminder');
            moveToFirstOfArray(newEventTypes, 'dot_renewal_reminder');
            moveToFirstOfArray(newEventTypes, 'wc_renewal_reminder');
          }
          dispatch(eventTypesFetched({ event_types: newEventTypes }));
        } else {
          dispatch(eventTypesFetched([]));
        }
      })
      .then(
        () =>
          // We can dispatch many times!
          // Here, we update the app state with the results of the API call.
          callback && dispatch(callback)
      )
      .catch((error) => {
        dispatch(reportError(error));
        dispatch(eventTypesRequestError(error));
      });
  };
}

function moveToFirstOfArray(eventTypes, type) {
  eventTypes.forEach((item, index) => {
    if (item.type === type) {
      eventTypes.unshift(...eventTypes.splice(index, 1));
    }
  });
  return eventTypes;
}
